import { useMutation } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { DOCUMENT_BASE_URL } from '.';

type CancelAutomationParams = {
  automationId: number;
};

type CancelAutomationResponse = {
  success: boolean;
};

const cancelAutomation = ({
  automationId,
}: CancelAutomationParams): Promise<CancelAutomationResponse> => {
  const url = generateRoutePath(`${DOCUMENT_BASE_URL}/automation/:automationId/cancel`, {
    automationId,
  });

  return axios.patch(url, null);
};

export const useCancelAutomation = (automationId: CancelAutomationParams) => {
  return useMutation({
    mutationFn: () => cancelAutomation(automationId),
  });
};
